import axios from '../configs/axios';
import { serializeQuery } from '../utility/helpers/serializeQuery';

class TransactionRepository {
    async getTransactionsByReferral(referralId, payload) {
        const response = await axios.get(
            `transaction/by_referral/${referralId}${
                !!payload ? `?${serializeQuery(payload)}` : ''
            }`,
        );

        return response;
    }

    async createReimbursement(payload) {
        const response = await axios.post('transaction/reimbursement', payload);
        return response;
    }

    async updateReimbursementStatus(transactionId, payload) {
        const response = await axios.put(
            `transaction/reimbursement/status/${transactionId}`,
            payload,
        );

        return response;
    }

    // async completeCashReimbursement(transactionId) {
    //     const response = await axios.put(
    //         `transaction/reimbursement/cash/complete/${transactionId}`,
    //     );

    //     return response;
    // }

    async getBillings(referralId, payload) {
        const response = await axios.get(
            `transaction/billings/${referralId}?${serializeQuery(payload)}`,
        );

        return response;
    }

    async getBillingsByLawyer(lawyerId, payload) {
        const response = await axios.get(
            `transaction/billingsByLawyer/${lawyerId}?${serializeQuery(
                payload,
            )}`,
        );

        return response;
    }

    async getTransactionsForReport(payload) {
        const response = await axios.get(
            `transaction/report?${serializeQuery(payload)}`,
        );
        return response;
    }

    async getTransactionById(transactionId) {
        const response = await axios.get(`transaction/by_id/${transactionId}`);
        return response;
    }

    async getPayoutsForReport() {
        const response = await axios.get('transaction/payout_report_elc');
        return response;
    }

    async getPayoutDetailsForReport(payoutId) {
        const response = await axios.get(
            `transaction/payout_report_elc/detail/${payoutId}`,
        );
        return response;
    }
}

export default new TransactionRepository();
